// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"d5633fc8","96":"7c083b99","100":"082040f3","147":"82b1399a","284":"a1b69f1a","302":"72818272","439":"3670d7e5","670":"57eb98b3","809":"f19d8740","870":"2e563446","958":"44dbbbb0","990":"5418b23a"}[chunkId] + ".chunk.js";
};